module.exports = __webpack_public_path__ + "static/media/YM74_1.60cbea33.jpg";